/**
 * Bundle 141 - Tools & Recovery landing page.
 * Route: /admin/tools
 */
import React from 'react';
import AdminSectionLandingPage from './AdminSectionLandingPage';

const AdminToolsLandingPage = () => (
  <AdminSectionLandingPage
    section="tools"
    testidPrefix="admin-tools-landing"
  />
);

export default AdminToolsLandingPage;
